import React from "react";

import style from "../../assets/scss/components/skeleton/skeleton-box.module.scss";

function SkeletonBox({ ...props }) {
  return <div {...props} className={style["skeleton-box"]} />;
}

export default SkeletonBox;
